import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

/**
 * Spinner component for loading states
 */
export function Spinner({ size = 'md', className = '' }) {
  const { t } = useTranslation();
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12',
  };

  return (
    <div
      className={`animate-spin inline-block border-[3px] border-current border-t-transparent text-blue-600 rounded-full ${sizeClasses[size]} ${className}`}
      role="status"
      aria-label={t('core.spinner.label')}
    >
      <span className="sr-only">{t('core.loading')}</span>
    </div>
  );
}

Spinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  className: PropTypes.string,
};
